import url from 'url';

import {BrowserRouter as Router, Route, Switch} from 'react-router-dom';
import React from 'react';

import AdminPage from './admin/AdminPage';
import EventPage from './event/EventPage';
import ThankYouPage from './event/ThankYouPage';
import SummaryPage from './event/SummaryPage';

import './App.css';

const hyVeeLogo = 'https://721695561982f42f75d3-9784fd013699897797da8b04ffded30e.ssl.cf2.rackcdn.com/hy-vee-logo.svg';
const NotFound = () => <p>{'Page not found'}</p>;
const App = () => (
    <Router basename={url.parse(process.env.PUBLIC_URL).pathname}>
        <div className="App">
            <header>
                <img
                    alt="hy-vee logo"
                    src={hyVeeLogo}
                />
            </header>

            <div className="App-route-content">
                <Switch>
                    <Route
                        component={AdminPage}
                        path="/hy-vee-admin-access"
                    />
                    <Route
                        component={ThankYouPage}
                        path="/event/:sheetId/:vendorId/:reservationId/thankyou"
                    />
                    <Route
                        component={SummaryPage}
                        path="/event/:sheetId/:vendorId/summary"
                    />
                    <Route
                        component={EventPage}
                        path="/event/:sheetId/:vendorId"
                    />
                    <Route
                        component={NotFound}
                    />
                </Switch>
            </div>

            <footer>
                <a
                    className="hy-vee-red heavy"
                    href="https://www.hy-vee.com/corporate/policy/privacy/"
                >
                    {'Privacy Policy'}
                </a>
                <div className="hy-vee-medium-dark-gray">{'Copyright 2018 Hy-Vee. All rights reserved.'}</div>
            </footer>
        </div>
    </Router>);

export default App;



// WEBPACK FOOTER //
// ./src/App.js